var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-breadcrumb" },
    [
      _c(
        "div",
        {
          staticStyle: {
            height: "30px",
            display: "flex",
            "align-items": "center",
          },
          attrs: { id: "statPanelSlider" },
          on: {
            click: function ($event) {
              return _vm.toggle()
            },
          },
        },
        [
          _c("Arrows", {
            class: { open: !_vm.largeHeader },
            staticStyle: { "margin-right": "5px" },
            attrs: { id: "arrows", "data-v-step": "1" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c(
            "div",
            {
              staticClass: "item",
              on: {
                click: function ($event) {
                  return _vm.chatMainMenu("/")
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.home")) +
                  "\n            "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.paths
          ? _c(
              "li",
              _vm._l(_vm.paths, function (item, index) {
                return _c(
                  "div",
                  {
                    key: "br-" + index,
                    staticClass: "item sec",
                    on: {
                      click: function ($event) {
                        item.path === "chat"
                          ? _vm.chatMainMenu(item.path)
                          : _vm.go(item.path)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(item.title) +
                        "\n            "
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showSubjects
          ? _c("li", [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedSubjectModel,
                      expression: "selectedSubjectModel",
                    },
                  ],
                  attrs: { id: "departSelect" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedSubjectModel = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "null" } }, [
                    _vm._v(_vm._s(_vm.$t("message.allDepartments"))),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.subjects, function (subject) {
                    return _c(
                      "option",
                      { key: subject._id, domProps: { value: subject._id } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              subject.languageContent[_vm.$i18n.locale].name
                            ) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.select
          ? _c(
              "li",
              { staticClass: "d-flex align-items-end" },
              [_vm._t("default")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("li", { staticClass: "ml-auto" }, [
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center",
            },
            [
              _vm.showTrialRemainDay &&
              _vm.trialInfo.trial &&
              _vm.settings &&
              _vm.settings.plan
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            theme: _vm.isDarkMode ? "light-border" : "google",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                    }",
                        },
                      ],
                      staticClass: "item four mr-2",
                      staticStyle: {
                        overflow: "hidden",
                        "text-overflow": "ellipsis",
                        display: "-webkit-box",
                        "-webkit-box-orient": "vertical",
                        "-webkit-line-clamp": "1",
                        "word-break": "break-all",
                      },
                      attrs: {
                        content: _vm.$t("billing.trialTimeInformation", {
                          dayCount: _vm.trialInfo.remainingDays,
                        }),
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "text-info bold",
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/billing")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("billing.trialTimeInformationShort", {
                                  dayCount: _vm.trialInfo.remainingDays,
                                })
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerDomainsFetched && !_vm.isSiteIntegrated()
                ? _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            theme: _vm.isDarkMode ? "light-border" : "google",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                    }",
                        },
                      ],
                      staticClass: "actionButtonBreadcrumb",
                      attrs: { content: _vm.$t("message.notIntegratedDesc") },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.integrationInstruction.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _c("md-icon", { staticStyle: { color: "red" } }, [
                        _vm._v("support"),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.notIntegrated")) +
                          "\n                "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.largeHeader
          ? _c(
              "li",
              [
                _c(
                  "md-button",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    staticClass: "actionButtonBreadcrumb m-0 w-100",
                    staticStyle: { "min-width": "20px", "max-width": "25px" },
                    attrs: {
                      content: _vm.socketConnected
                        ? _vm.$t("message.connectServer")
                        : _vm.$t("message.disconnectServer"),
                    },
                    on: { click: _vm.disconnectSocket },
                  },
                  [
                    _c(
                      "div",
                      { class: { blinkAnimation: !_vm.socketConnected } },
                      [
                        _c(
                          "md-icon",
                          {
                            style: {
                              color: _vm.socketConnected ? "green" : "red",
                            },
                          },
                          [_vm._v("wifi\n                    ")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.largeHeader && _vm.whatsappEnabled
          ? _c(
              "li",
              [
                _c(
                  "md-button",
                  {
                    staticClass: "actionButtonBreadcrumb m-0",
                    staticStyle: { "min-width": "20px", "max-width": "25px" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push("/integrations/whatsapp")
                      },
                    },
                  },
                  [
                    _c(
                      "md-icon",
                      {
                        style: {
                          color: !_vm.wpInfo.initialized
                            ? "gray"
                            : _vm.whatsappServiceIsHealthy
                            ? "green"
                            : "red",
                        },
                      },
                      [_vm._v("whatsapp")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.largeHeader
          ? _c(
              "li",
              [
                _c(
                  "md-button",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    staticClass: "actionButtonBreadcrumb m-0",
                    staticStyle: { "min-width": "20px", "max-width": "25px" },
                    attrs: {
                      content: _vm.offlineMode
                        ? _vm.$t("message.liveChatOff")
                        : _vm.$t("message.liveChatOn"),
                    },
                  },
                  [
                    _c(
                      "md-icon",
                      { style: { color: _vm.offlineMode ? "red" : "green" } },
                      [_vm._v("support_agent")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.largeHeader
          ? _c("li", { staticClass: "item four" }, [
              _c("span", { staticClass: "date" }, [
                _vm._v(_vm._s(_vm.$t("time.today")) + ":"),
              ]),
              _c("span", { staticClass: "time" }, [
                _vm._v(_vm._s(_vm.getToday())),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.largeHeader ? _c("HeaderRight") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }